//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory7Lang', {
//        templateUrl: 'views/components/views/textileModelCategory7Lang/textileModelCategory7Lang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'textileModelCategory7LangService', function ($stateParams, stateService, textileModelCategory7LangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory7Keyno = $stateParams.textilemodelcategory7_keyno;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await textileModelCategory7LangService.listTextileModelCategory7Languages({ textilemodelcategory7_keyno: textileModelCategory7Keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory7LangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
